<template>
  <DBox
    :id="'cmp-catalog-product_groups-sidewindow-product_groups-group'"
    :addButton="false"
  >
    <TextField2
      :disabled="selectedProduct_groupDetails.disabled"
      :id="'product_group_name1'"
      :placeholder="$t('name')"
      :label="$t('name')"
      :value="selectedProduct_groupDetails.product_group.product_group_name1"
      @blur="onTextFieldValueChange"
    />

    <TextField2
      :disabled="selectedProduct_groupDetails.disabled"
      :id="'product_group_name2'"
      :placeholder="$t('alternate_name')"
      :label="$t('alternate_name')"
      :value="selectedProduct_groupDetails.product_group.product_group_name2"
      @blur="onTextFieldValueChange"
    />

    <TextField2
      :disabled="selectedProduct_groupDetails.disabled"
      :id="'notes'"
      :placeholder="$t('notes')"
      :label="$t('notes')"
      :value="selectedProduct_groupDetails.product_group.notes"
      @blur="onTextFieldValueChange"
      bb="0px"
    />
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { EventHooks } from "../../../../plugins/text-field";

export default {
  components: {
    DBox
  },
  props: {
    selectedProduct_groupDetails: {
      required: true
    }
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      }
    };
  },
  mounted: function() {
    // console.log("Product Grouppppppp", this.selectedProduct_groupDetails.product_group.product_group_name1);
  },
  methods: {
    onTextFieldValueChange: function(event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-product_groups-sidewindow-product_groups-group {
}
</style>
